// src/pages/Ping.js

function Ping() {
    return <div>{"status: ok"}</div>;
}
  
export default Ping;
  